export default __webpack_public_path__ + "static/media/check-black.a70a57b9.svg";